<script setup>
    import { computed } from 'vue';
    import VariableWidthCard from 'shared/components/contentElements/variableWidthCard.vue';
    import StaticWidthCard from 'shared/components/contentElements/staticWidthCard.vue';
	import { DsText } from '@coloplast/design-system';

    const props = defineProps({
        vm: {
            type: Object,
            default: () => {},
        },
    });

    const layoutType = computed(() => {
        let layoutTypeIndex = props.vm.CurrentBlock.LayoutType;
        switch (layoutTypeIndex) {
            case '1':
                return 'staticWidth';
            case '2':
                return 'staticWidthNoImage';
            default:
                return 'variableWidth';
        }
    });
</script>

<template>
    <div
        class="c-content-recommended__container"
        :class="{ 'c-content-recommended__container--static-width': layoutType !== 'variableWidth' }"
    >
		<DsText
			v-if="vm.CurrentBlock.Headline"
			html-element="h2"
			text-type="heading-2xl"
			class="c-content-recommended__heading"
			:class="{ 'c-content-recommended__heading--static-width': layoutType !== 'variableWidth' }"
		>
			<div v-html="vm.CurrentBlock.Headline"></div>
		</DsText>
		<DsText
			v-if="vm.CurrentBlock.Description && layoutType !== 'variableWidth'"
			class="c-content-recommended__description"
		>
			<div v-html="vm.CurrentBlock.Description"></div>
		</DsText>
        <div
            v-if="layoutType === 'variableWidth'"
            class="c-content-recommended__wrapper"
            :class="{ 'c-content-recommended__wrapper--four': vm.BaseViewModel.Items.length === 4 }"
        >
            <variable-width-card
                v-for="contentRecommendedItem in vm.BaseViewModel.Items"
                :key="contentRecommendedItem.Id"
                :item="contentRecommendedItem"
                :items-length="vm.BaseViewModel.Items.length"
            />
        </div>
        <div
            v-if="layoutType !== 'variableWidth'"
            class="c-content-recommended__wrapper c-content-recommended__wrapper--static"
            :class="{ 'c-content-recommended__wrapper--four': vm.BaseViewModel.Items.length === 4 }"
        >
            <static-width-card
                v-for="contentRecommendedItem in vm.BaseViewModel.Items"
                :key="contentRecommendedItem.Id"
                :item="contentRecommendedItem"
                :is-without-an-image="layoutType === 'staticWidthNoImage'"
            />
        </div>
    </div>
</template>
